module.exports = __webpack_public_path__ + "16a0af28a392745ccb046bdc8cd583b8.png";